import { ValidatableEntity } from "components/validation/validatableentity";
import { Validator } from "components/validation/validator";
import { StoreActionApi } from "react-sweet-state";
import { storeAction } from "./immersetup";
import { LoadingState, LoadingStateDefaults } from "./loadingstate";
import {
    getEntityField as getStateEntityField,
    setEntityField as setStateEntityField,
    setStateField as setStateRootField
} from "./setfield";

import { Container } from "./types";

interface Entity extends Container {
};

interface State<EntityType = Entity> extends LoadingState, ValidatableEntity<EntityType> {
}
const StateDefaults: State = {
    ...LoadingStateDefaults,
    entity: {},
    collection: [],
    errors: {}
}

type StoreApi<S extends State> = StoreActionApi<S>;

const createEntityFieldGetter = <EntityType>(state: State<EntityType>) =>
    (field: string) =>
        getStateEntityField(state, field);

function setStateField<EntityType>(
    field: string,
    value: boolean | string | number,
    validator: Validator<any> = null,
    storeInvalidValue: boolean = true) {
    return storeAction<State<EntityType>>((draft: State<EntityType>) => {
        setStateRootField(draft, field, value, validator, storeInvalidValue);
    });
}

function setEntityField<EntityType>(
    field: string,
    value: boolean | string | number,
    validator: Validator<any> = null,
    storeInvalidValue: boolean = true) {
    return storeAction<State<EntityType>>((draft: State<EntityType>) => {
        setStateEntityField(draft, field, value, validator, storeInvalidValue);
    });
}

export {
    Entity,
    createEntityFieldGetter,
    setEntityField,
    setStateField,
    State as EntityState,
    StateDefaults as EntityStateDefaults,
    StoreApi as EntityStoreApi,
}
